import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { AnalyticsService } from "../../../auth/service/analytics.service";
import { BUDGET, CANDIDATES_FOR_RECRUITERS, CANDIDATES_OK_KO, CHART_PIE, EDGE_FOR_CLIENTS, HIRED_RESIGN, NEGOTIATION, REVENUE_REPORT, SALES_COSTS, SKILLS, STATE_TICKET } from "./analytics.config";

@Component({
  selector: "app-analytics",
  templateUrl: "./analytics.component.html",
  styleUrls: ["./analytics.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AnalyticsComponent implements OnInit {
  chartOptionsHiredResign = HIRED_RESIGN;
  chartoptionsStateTickets = STATE_TICKET;
  chartOptionsPie = CHART_PIE;
  chartOptionsRevenueReport = REVENUE_REPORT;
  chartOptionsBudget = BUDGET;
  chartOptionsSkills = SKILLS;
  chartOptionsCandidatesForRecruiters = CANDIDATES_FOR_RECRUITERS;
  chartOptionsCandidatesOKKO = CANDIDATES_OK_KO;
  chartOptionsSalesCosts = SALES_COSTS;
  chartOptionsEdgeForClients = EDGE_FOR_CLIENTS;
  chartOptionsNegotiation = NEGOTIATION;

  dataHiredResign;
  dataStateTickets;
  dataEmployeesRole;
  dataClientSalesVolume;
  dataRevenueReport;
  dataBudget;
  dataSkills;
  dataCandidatesForRecruiters;
  dataCandidatesOKKO;
  dataSalesCosts;
  dataEdgeForClients;
  dataMostRequestedJobs;
  dataQualifications;
  dataNegotiation;
  dataCandidatesRole;
  dataProviderAndStruturalCosts;

  constructor(private _analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this._analyticsService.dataHiredResign.subscribe((resp) => {
      this.dataHiredResign = resp;
    });

    this._analyticsService.dataStateTickets.subscribe((resp) => {
      this.dataStateTickets = resp;
    });

    this._analyticsService.dataEmployeesRole.subscribe((resp) => {
      this.dataEmployeesRole = resp;
    });

    this._analyticsService.dataClientSalesVolume.subscribe((resp) => {
      this.dataClientSalesVolume = resp;
    });

    this._analyticsService.dataRevenueReport.subscribe((resp) => {
      this.dataRevenueReport = resp;
    });

    this._analyticsService.dataBudget.subscribe((resp) => {
      this.dataBudget = resp;
    });

    this._analyticsService.dataSkills.subscribe((resp) => {
      this.dataSkills = resp;
    });

    this._analyticsService.dataCandidatesForRecruiters.subscribe((resp) => {
      this.dataCandidatesForRecruiters = resp;
    });

    this._analyticsService.dataCandidatesOKKO.subscribe((resp) => {
      this.dataCandidatesOKKO = resp;
    });

    this._analyticsService.dataSalesCosts.subscribe((resp) => {
      this.dataSalesCosts = resp;
    });

    this._analyticsService.dataEdgeForClients.subscribe((resp) => {
      this.dataEdgeForClients = resp;
    });

    this._analyticsService.dataMostRequestedJobs.subscribe((resp) => {
      this.dataMostRequestedJobs = resp;
    });

    this._analyticsService.dataQualifications.subscribe((resp) => {
      this.dataQualifications = resp;
    });

    this._analyticsService.dataNegotiation.subscribe((resp) => {
      this.dataNegotiation = resp;
    });

    this._analyticsService.dataCandidatesRole.subscribe((resp) => {
      this.dataCandidatesRole = resp;
    });

    this._analyticsService.dataProviderAndStruturalCosts.subscribe((resp) => {
      this.dataProviderAndStruturalCosts = resp;
    });
  }
}
